import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
  },
  banner: {
    display: 'flex',
    alignItems: 'center',
    padding: '26px 28px',
    borderRadius: 14,
    background: 'linear-gradient(135deg, #ffffff 0%, #f3f5f8 100%)',
    border: '1px solid rgba(0,0,0,0.05)',
    boxShadow: '0 2px 10px rgba(0,0,0,0.04)',
    boxSizing: 'border-box',
  },
  avatar: {
    width: 60,
    height: 60,
    borderRadius: 14,
    backgroundColor: theme.palette.primary.main,
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 700,
    fontSize: '1.4rem',
    marginRight: theme.spacing(3),
    flexShrink: 0,
  },
  textContainer: {
    flex: 1,
    minWidth: 0,
  },
  greeting: {
    fontWeight: 700,
    fontSize: '1.3rem',
    marginBottom: 6,
    color: '#333',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  info: {
    fontSize: '1rem',
    color: '#555',
    opacity: 0.85,
    lineHeight: 1.5,
    whiteSpace: 'normal',
  },
}));

const BannerMentora = ({ nombre, informacion }) => {
  const classes = useStyles();
  const inicial = (nombre || '').trim().charAt(0).toUpperCase() || '?';
  return (
    <div className={classes.root}>
      <div className={classes.banner}>
        <div className={classes.avatar}>{inicial}</div>
        <div className={classes.textContainer}>
          <Typography className={classes.greeting}>
            Hola, {nombre.toUpperCase()}!
          </Typography>
          <Typography className={classes.info}>
            {informacion}
          </Typography>
        </div>
      </div>
    </div>
  );
};

export default BannerMentora;
